<template>
    <v-container class="px-4" style="background:white;">
        <!-- Filtros -->
        <v-navigation-drawer style="top: 0px; max-height:100vh!important;" right v-model="showFilter" :clipped="$vuetify.breakpoint.lgAndUp" app>
            <filterInventory @filtersItem="filtersItem"/>
        </v-navigation-drawer>
        <!-- header -->
        <v-toolbar flat class="mb-2">
            <v-toolbar-title>
                Inventario
            </v-toolbar-title>
            <v-btn icon class="ml-6" v-if="filtersLength > 0" @click="openFilter()">
                <v-badge overlap color="primary">
                    <template v-slot:badge>
                        {{filtersLength}}
                    </template>
                    <v-icon>mdi-filter</v-icon>
                </v-badge>
            </v-btn>
            <v-btn icon class="ml-6 pt-2" v-else @click="openFilter()">
                <v-icon>mdi-filter</v-icon>
            </v-btn>
            <v-menu bottom left offset-y v-show="permissions('download')">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" :loading="exporting">
                        <v-icon>mdi-download</v-icon>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item @click="exportExcel(false)">
                        <v-list-item-title>Lo que se ve en pantalla</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportExcel(true)">
                        <v-list-item-title>Todo</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-spacer/>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                @keydown.enter="getDataFromApi()"
            ></v-text-field>
        </v-toolbar>
        <!-- tabla -->
        <v-data-table  
            fixed-header
            :footer-props="{'items-per-page-options':[15, 30, 50, totalItems]}"
            :options.sync="options"
            :server-items-length="totalItems"
            :loading="loading"
            :headers="headers" 
            :items="items" 
            class="elevation-0 px-6 py-4 inventory_table"
            :item-class="itemRowBackground" 
            >
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                    </template>
                    <v-list style="font-size:13px;">
                        <v-list-item @click="editedItem=item, editDialog=true" v-if="permissions('editProduct')">
                            <v-icon small class="mr-2">mdi-pencil</v-icon> Editar
                        </v-list-item>
                        <v-list-item @click="openLabelDialog(item)">
                            <v-icon small class="mr-2">mdi-printer</v-icon> Imprimir Etiqueta
                        </v-list-item>
                    </v-list>
                </v-menu>
                <!--v-icon small @click="deleteItem(item.id)" v-if="permissions('deleteProduct')">mdi-delete</v-icon-->
            </template>
            <template v-slot:[`item.is_published`]="{ item }">
                <v-icon v-if="item.is_published" color="green"> mdi-check </v-icon>
                <v-icon v-else color="red"> mdi-close </v-icon>
            </template>
            <template v-slot:[`item.facturapi_validated`]="{ item }">
                <v-chip x-small :color="item.facturapi_id ? 'success' : 'grey'" dark>
                    {{ item.facturapi_id ? 'Sí' : 'No' }}
                </v-chip>
            </template>
            <template v-slot:[`item.price`]="{ item }">
                {{money(item.price)}}
            </template>
            <template v-slot:[`item.name`]="{ item }">
                <v-list-item class="px-0" style="min-height:0px!important; font-size:14px;" :to="{ path: '/inventory-reports/'+ item.id}">{{item.name}}</v-list-item>
            </template>
            <template v-slot:[`item.categories`]="{ item }">
                {{ categoryNames(item.categories) }}
            </template>
            <template v-slot:[`item.brand`]="{ item }">
                {{ brandName(item.brand) }}
            </template>
            <template v-slot:[`item.price_two`]="{ item }">
                {{money(item.price_two)}}
            </template>
            <template v-slot:[`item.price_three`]="{ item }">
                {{money(item.price_three)}}
            </template>
            <template v-slot:[`item.price_four`]="{ item }">
                {{money(item.price_four)}}
            </template>
            <template v-slot:[`item.cost`]="{ item }">
                {{money(item.cost)}}
            </template>
            <template v-slot:[`item.inventory_cost`]="{ item }">
                {{money(item.inventory_cost)}}
            </template>
            <template v-slot:[`item.current_cost`]="{ item }">
                {{money(item.current_cost)}}
            </template>
            <template v-slot:[`item.branch_inventories`]="{ item }">
                <div>
                    <li v-for="(value, key) in filterBranchInventory(item.branch_inventories)" :key="key">
                        {{ key }}: {{ value }}
                    </li>
                </div>
            </template>
        </v-data-table>
        <!-- avisos -->
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
        <!-- crear -->
        <v-dialog v-model="createDialog" max-width="1080px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn bottom color="#e25200" dark fab fixed right v-bind="attrs" v-on="on">
                <v-icon color="white">  mdi-plus </v-icon>
            </v-btn> 
          </template>
          <createMfItem v-if="liga == 'https://backendmf.unocrm.mx/'" @closeDialogItem="closeDialogItem"/>
          <createFelItem v-else @closeDialogItem="closeDialogItem"/>
        </v-dialog>
        <!-- editar -->
        <v-dialog v-model="editDialog" max-width="1080px" @click:outside="editDialog=false">
            <editMfItem v-if="liga == 'https://backendmf.unocrm.mx/' && editDialog" v-bind:editedItem="editedItem" @closeDialogItem="closeDialogItem"/>
            <editFelItem v-else-if="editDialog" @closeDialogItem="closeDialogItem" v-bind:editedItem="editedItem"/>
        </v-dialog> 
        <!-- Dialogo confirmación de eliminación -->
        <div class="text-center" >
            <v-bottom-sheet  v-model="sheet" inset>
                <v-sheet class="text-center" height="150px">
                    <div class="pt-6">
                    ¿Seguro que deseas borrar este producto?
                    </div>
                    <v-btn class="mt-4" text color="error" @click="deleteNow()">
                    Eliminar
                    </v-btn>
                    <v-btn class="mt-4" text color="grey" @click="sheet=false, deleteId=''">
                    Cancelar
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </div>
        <v-dialog v-model="labelDialog" max-width="240px">
            <v-card>
                <v-card-title class="justify-space-between">
                    <span>Imprimir etiqueta</span>
                    <v-btn icon @click="labelDialog = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <div id="product-label-print" class="product-label">
                        <div class="label-name">{{ selectedLabelItem.name }}</div>
                        <svg v-show="selectedLabelValue" ref="barcode"></svg>
                        <div class="label-code">{{ selectedLabelValue }}</div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="grey" @click="labelDialog = false">Cerrar</v-btn>
                    <v-btn color="primary" @click="printLabel">Imprimir</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios';
import JsBarcode from 'jsbarcode'
import editFelItem from "../inventory/edit_fel"
import createFelItem from "../inventory/create_fel"
import filterInventory from "../inventory/pos_filter"
import createMfItem from "../inventory/create_mf"
import editMfItem from "../inventory/edit_mf"
export default {
    components: {
        'filterInventory':filterInventory,
        'createFelItem':createFelItem,
        'editFelItem': editFelItem,
        'createMfItem': createMfItem,
        'editMfItem': editMfItem
    },
    data(){
        return{
            sheet:false,
            options: {},
            loading: true,
            exporting: false,
            snackbar: {
                show: false,
                message: null,
                color: null
            },
            totalItems:0,
            showFilter:false,
            filters:{
                publish:'',
                facturapi_validation:'',
                category:'',
                brand:[],
                inventory_stock:'',
            },
            search:'',
            items:[],
            editDialog:false,
            createDialog:false,
            editedItem:{},
            labelDialog:false,
            selectedLabelItem:{},
            deleteId:''
        }
    },
    created(){
        const savedFilters = localStorage.getItem('selectorFiltersInventoryPos')
        if(savedFilters){
            this.filters = {
                ...this.filters,
                ...JSON.parse(savedFilters),
            }
        }
    },
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
            },
            deep: true,
        },
        labelDialog(val) {
            if (val) {
                this.$nextTick(() => {
                    this.renderBarcode()
                })
            }
        },
        selectedLabelValue() {
            if (this.labelDialog) {
                this.$nextTick(() => {
                    this.renderBarcode()
                })
            }
        }
    },
    computed:{
        liga(){
            return process.env.VUE_APP_BACKEND_ROUTE
        },
        selectedLabelValue(){
            return this.selectedLabelItem.code_three || this.selectedLabelItem.code_one || this.selectedLabelItem.code_two || ''
        },
        currentUser(){
            return this.$store.state.currentUser.user
        },
        headers(){
            var headers = [
                {text:'id', value:'id'},
                {text:'Nombre', value:'name'},
                {text:'Categoría', value:'categories'},
                {text:'Marca', value:'brand'},
                {text:'Inventario', value: this.liga!='https://backendmf.unocrm.mx/'?'current_inventory':'branch_inventories', sortable: this.liga!='https://backendmf.unocrm.mx/'},
                {text:'Inventario Mínimo', value:'ideal_inventory'},
                {text: 'Publicado', value: 'is_published'},
                {text: 'Facturapi', value: 'facturapi_validated', sortable:false},
                {text:'Código 1', value:'code_one'},
            ]
            return headers.concat(this.codes).concat(this.costHeader).concat([{ value: 'actions', sortable: false, align: 'end', }])
        },
        codes(){
            var headers=[]
            if(this.liga!='https://backendmf.unocrm.mx/'){
                headers =  [
                    {text:'Código 2', value:'code_two'},
                    {text:'Código de barras', value:'code_three'},
                ]
            }
            headers.push({text:'Código SAT', value:'sat_key_code'})
            if(this.liga!='https://backendmf.unocrm.mx/'){
                headers = headers.concat([
                    {text:this.liga != 'https://backend.ferreteriaenlinea.com/'?'Precio 1*':'Precio Mayoreo', value:'price'},
                    {text:'Precio 2', value:'price_two'},
                    {text:'Precio 3', value:'price_three'},
                    {text:this.liga != 'https://backend.ferreteriaenlinea.com/'?'Precio 4':'Precio Mostrador', value:'price_four'},
                ])
            }
            return headers
        },
        costHeader(){
            if(this.permissions('view_costs')){
                return [
                    {text:'Costo', value:this.liga!='https://backendmf.unocrm.mx/'?'current_cost':'cost'},
                    {text:'Costo Inventario', value:'inventory_cost'}
                ]
            }else{
                return []
            }
        },
        filtersLength(){
            var count = 0
            if(this.filters.publish !== '' && this.filters.publish !== null && this.filters.publish !== undefined){
                count++
            }
            if(this.filters.facturapi_validation !== '' && this.filters.facturapi_validation !== null && this.filters.facturapi_validation !== undefined){
                count++
            }
            if(this.filters.category && this.filters.category.length > 0){
                count++
            }
            if(this.filters.brand && this.filters.brand.length > 0){
                count++
            }
            if(this.filters.inventory_stock !== '' && this.filters.inventory_stock !== null && this.filters.inventory_stock !== undefined){
                count++
            }
            return count
        },
    },
    methods: {
        itemRowBackground() {
            return ''
        },
        filterBranchInventory(branchInventories) {
            const branch_name = this.currentUser.branch[0].name
            if(this.currentUser){
                const filteredInventories = {};
                if (branch_name == 'CDMX') {
                    // Si el nombre de la sucursal es igual a CDMX, devolver solo el inventario de CDMX
                    filteredInventories[branch_name] = branchInventories[branch_name];
                } else {
                    // Si el nombre de la sucursal no es CDMX, devolver todo excepto el inventario de CDMX
                    for (const key in branchInventories) {
                        if (key != 'CDMX') {
                            filteredInventories[key] = branchInventories[key];
                        }
                    }
                }
                return filteredInventories;
            }
        },
        permissions(permission){
            if(this.currentUser.id==1){
                return true
            }else if(this.currentUser.permissions!=undefined){
                if(this.currentUser.permissions.includes(permission)){
                    return true
                }else{
                    return false
                }
            }else{
                return false
            }
        },
        deleteItem (id) {
            this.deleteId = id
            this.sheet = true
        },
        deleteNow(){
            axios.delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/items/"+this.deleteId).then(() => {
                this.deleteId = ''
                this.sheet = false
                this.getDataFromApi()
            }).catch(error => {
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'error',
                    show: true
                }
            });
        },
        money(amount){
            if(amount!=undefined){
                return (amount*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})
            }else{
                return '-'
            }
        },
        categoryNames(categories){
            if(!categories || categories.length < 1){
                return '-'
            }
            return categories.map(category => category.name).join(', ')
        },
        brandName(brand){
            return brand && brand.name ? brand.name : '-'
        },
        openLabelDialog(item) {
            this.selectedLabelItem = item || {}
            this.labelDialog = true
        },
        renderBarcode() {
            if (!this.$refs.barcode || !this.selectedLabelValue) return
            JsBarcode(this.$refs.barcode, String(this.selectedLabelValue), {
                format: 'CODE128',
                width: 1.2,
                height: 26,
                displayValue: false,
                margin: 0,
            })
        },
        printLabel() {
            const barcodeSvg = this.$refs.barcode ? this.$refs.barcode.outerHTML : ''
            if (!barcodeSvg) return
            const safeName = this.selectedLabelItem.name || ''
            const safeCode = this.selectedLabelValue || ''
            const printWindow = window.open('', '_blank', 'width=240,height=160')
            printWindow.document.write(`
                <html>
                    <head>
                        <title>Etiqueta</title>
                        <style>
                            @page {
                                size: 2in 1in landscape;
                                margin: 0;
                            }
                            html, body {
                                margin: 0;
                                padding: 0;
                                width: 2in;
                                height: 1in;
                                background: white;
                                overflow: hidden;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }
                            body {
                                font-family: Arial, sans-serif;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                box-sizing: border-box;
                            }
                            .product-label {
                                width: 2in;
                                height: 1in;
                                padding: 0.03in 0.05in 0.02in;
                                box-sizing: border-box;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                                gap: 0.015in;
                                overflow: hidden;
                            }
                            .label-name {
                                font-size: 9px;
                                font-weight: 700;
                                text-align: center;
                                line-height: 1.05;
                                width: 100%;
                                max-height: 0.22in;
                                overflow: hidden;
                            }
                            .label-barcode {
                                width: 100%;
                                flex: 1;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                overflow: hidden;
                            }
                            .label-code {
                                font-size: 7px;
                                line-height: 0.95;
                                letter-spacing: 0.015in;
                                text-align: center;
                                width: 100%;
                                white-space: nowrap;
                                overflow: hidden;
                            }
                            svg {
                                width: 1.75in !important;
                                max-width: 1.75in !important;
                                height: 0.3in !important;
                                display: block;
                                margin: 0 auto;
                            }
                        </style>
                    </head>
                    <body>
                        <div class="product-label">
                            <div class="label-name">${safeName}</div>
                            <div class="label-barcode">${barcodeSvg}</div>
                            <div class="label-code">${safeCode}</div>
                        </div>
                    </body>
                </html>
            `)
            printWindow.document.close()
            printWindow.focus()
            setTimeout(() => {
                printWindow.print()
                printWindow.close()
            }, 300)
        },
        getDataFromApi () {
            this.loading = true
            this.apiCall().then(data => {
                this.items = data.items
                this.totalItems = data.total
                this.loading = false
            })
        },
        exportExcel: async function (all = false) {
            this.exporting = true
            try {
                const response = await axios.get(
                    process.env.VUE_APP_BACKEND_ROUTE + "api/v2/item/pos?" + this.buildInventoryQuery(all, true),
                    {
                        responseType: 'blob',
                        headers: {
                            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        }
                    }
                )
                this.downloadFile(response.data, this.getExportFilename(response))
            } finally {
                this.exporting = false
            }
        },
        buildInventoryQuery(all = false, exportFile = false){
            const { sortBy = [], sortDesc = [], page = 1, itemsPerPage = 15 } = this.options
            const params = new URLSearchParams()

            if (sortBy.length === 1 && sortDesc.length === 1) {
                params.set('sort', (sortDesc[0] ? '-' : '') + sortBy[0])
            }
            if(this.search!=''){
                params.set('filter[pos]', this.search)
            }
            if(this.filters.publish !== '' && this.filters.publish !== null && this.filters.publish !== undefined){
                params.set('filter[is_published]', this.filters.publish)
            }
            if(this.filters.facturapi_validation !== '' && this.filters.facturapi_validation !== null && this.filters.facturapi_validation !== undefined){
                params.set('filter[facturapi_validation]', this.filters.facturapi_validation)
            }
            if(this.filters.inventory_stock !== '' && this.filters.inventory_stock !== null && this.filters.inventory_stock !== undefined){
                params.set('filter[inventory_stock]', this.filters.inventory_stock)
            }
            if(this.filters.category && this.filters.category.length > 0){
                params.set('filter[categories]', this.filters.category.join(','))
            }
            if(this.filters.brand && this.filters.brand.length > 0){
                params.set('filter[brand_id]', this.filters.brand.join(','))
            }

            params.set('page', all ? 1 : page)
            params.set('itemsPerPage', all ? (this.totalItems || itemsPerPage) : itemsPerPage)

            if(exportFile){
                params.set('export', 1)
            }

            return params.toString()
        },
        getExportFilename(response) {
            const disposition = response.headers?.["content-disposition"] || "";
            const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
            if (match && match[1]) {
                return match[1].replace(/['"]/g, "");
            }
            return `inventario_pos_${new Date().toISOString().slice(0, 10)}.xlsx`;
        },
        downloadFile(blobData, filename) {
            const url = window.URL.createObjectURL(new Blob([blobData]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        },
        apiCall () {
            return new Promise((resolve) => {
                var items = []
                var total = 0
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/item/pos?" + this.buildInventoryQuery()).then(response => {
                    items = response.data.data.map(id=>{return{
                        ...id,
                        provider_id:id.provider!=null?id.provider.id:null,
                        brand_id:id.brand!=null?id.brand.id:null
                    }})
                    
                    /*.map(d=>{return{
                        ...d,
                        taxes:d.taxes!=null?d.taxes:[{
                            rate:16,
                            base:100,
                            type:'IVA',
                            factor:'Tasa',
                            withholding:false,
                        }]
                    }})*/
                    total = response.data.meta.total
                    resolve({
                        items,
                        total,
                    })
                })
            })
        },
        openFilter(){
            this.showFilter = !this.showFilter
        },
        filtersItem: function(params) {
            this.filters = params
            this.options.page = 1
            this.showFilter = false
            this.getDataFromApi()
        },
        closeDialogItem: function(params) {
            this.editedItem = {}
            this.editDialog = params;
            this.createDialog = params;
            this.getDataFromApi()
        },
    },
};
</script>
<style>
.faltaProducto{
    background-color:red;
}

.inventory_table .v-data-table__wrapper{
    height: calc(100vh - 100px);
}

.product-label {
    background: white;
    width: 2in;
    height: 1in;
    padding: 0.03in 0.05in 0.02in;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.015in;
    overflow: hidden;
}

.label-name {
    font-size: 9px;
    font-weight: 700;
    line-height: 1.05;
    max-height: 0.22in;
    overflow: hidden;
}

.label-code {
    font-size: 7px;
    line-height: 0.95;
    letter-spacing: 0.015in;
    white-space: nowrap;
    overflow: hidden;
}

.product-label svg {
    width: 1.75in !important;
    max-width: 1.75in !important;
    height: 0.3in !important;
}
</style>
